import { i18n } from '../../internationalize/i18n.service'

export class NumberFormatter {
    private numberPrefix = new Map<NumberType, string>([
        [NumberType.price, '$'],
        [NumberType.bitcoinPrice, '₿'],
        [NumberType.ethereumPrice, 'Ξ'],
    ])

    private formatNumber(number: number): string {
        const hasDecimals = number % 1 !== 0;
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: hasDecimals ? 2 : 0,
            maximumFractionDigits: 2,
            useGrouping: true
        }).format(number).replace(/,/g, ' ');
    }

    defaultFormat(number: number, type: NumberType | undefined = undefined): string {
        const prefixString = type ? this.numberPrefix.get(type) || '' : '';
        const absNumber = Math.abs(number);

        const thresholds = [
            { value: 1e9, suffix: i18n.t('billions_separator') },
            { value: 1e6, suffix: i18n.t('millions_separator') },
            { value: 1e3, suffix: i18n.t('thousands_separator') }
        ];

        const match = thresholds.find(t => absNumber >= t.value);

        if (match) {
            const scaledNumber = absNumber / match.value;
            const formatted = this.formatNumber(scaledNumber);
            return `${prefixString + (number < 0 ? '-' : '')} ${formatted} ${match.suffix}`;
        } else {
            const formatted = this.formatNumber(absNumber);
            return `${prefixString + (number < 0 ? '-' : '')} ${formatted}`;
        }
    }

    percentFormat(number: number): string {
        return `${this.formatNumber(number)} %`;
    }
}

export enum NumberType {
    number = 'number',
    price = 'price',
    percent = 'percent',
    bitcoinPrice = 'bitcoinPrice',
    ethereumPrice = 'ethereumPrice',
}

export const numberFormatters = new NumberFormatter()